import React from "react";

const WelcomeModal = ({
  handleOpenDownloadForm,
  handleOpenUserForm,
  show,
  handleOpenPaymentEvidenceForm,
}) => {
  if (!show) return null;

  return (
    <div className="text-justify">
      <h3 className="mb-6 text-xl font-semibold leading-snug">
        Thank you for your interest in joining the ESG Governance Awards 2025!
      </h3>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        Please complete in the following Request for Information truthfully
        based on your company's actual practices. The information you share will
        remain confidential and will be used solely for the purpose of award
        evaluation.
      </p>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        We encourage you to provide clear, concise answers and attach any
        supporting evidence or disclosures that best reflect your ESG journey
        and governance.
      </p>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        The submission deadline is <b>Friday, May 22, 2026</b> — make sure
        to submit on time.
      </p>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        We look forward to learning from your sustainability story!
      </p>
      <div className="flex flex-col gap-3 pt-2 sm:flex-row">
        <div
          className="px-4 py-2 rounded-md bg-[#FFCD4F] text-black hover:bg-[#E5A426] transition text-sm font-medium cursor-pointer text-center"
          onClick={() => handleOpenDownloadForm()}
        >
          Download Form
        </div>
        <div
          className="px-4 py-2 rounded-md bg-[#F58220] text-white hover:bg-[#D67E32] transition text-sm font-medium cursor-pointer text-center"
          onClick={() => handleOpenUserForm()}
        >
          Submit Form
        </div>
      </div>
      <div className="flex flex-col gap-3 pt-2 sm:flex-row">
        <div
          className="px-4 py-2 rounded-md bg-[#8DC63F] text-white hover:bg-lime-600 transition text-sm font-medium cursor-pointer text-center"
          onClick={() => handleOpenPaymentEvidenceForm()}
        >
          Upload payment evidence
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
